import { IsString, MinLength, IsBoolean } from "class-validator";

export class AuthVerifyEmailInputDTO {
	@IsString()
	token: string;
}

export class AuthVerifyEmailOutDTO {
	@IsBoolean()
	success: boolean;

	errors?: {
		invalidToken?: boolean
	}
}
